import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export const isCurrentFragment = ({ startTime, endTime }: SkippableFragment, currentTime: number) =>
    startTime < currentTime && currentTime < endTime;
